import React, { FC } from 'react';
import cx from 'classnames';
import './CountOfTotal.scss';

interface CountOfTotalProps {
  className?: string;
  content: string | null | undefined;
  maxCnt: number;
}

const CountOfTotal: FC<CountOfTotalProps> = (props) => {
  const { className, content = '', maxCnt } = props;

  return (
    <div className={cx('count-of-total', className)}>
      (<span> {content ? content.length : 0} </span>/{maxCnt})
    </div>
  );
};

export default CountOfTotal;
